import { orderBy } from "lodash";
import { useMemo } from "react";
import packagingRegistry from "./packagingRegistry";

export const usePackagingRegistrations = () => {
    return useMemo(() => {
        return orderBy(packagingRegistry.getAllRegistrations(), ["displayOrder", "name"]);
    }, []);
};

export default usePackagingRegistrations;
